import { ConfiguratorType, getConfiguratorTypeFromProductCode } from "../types/ConfiguratorType";

export const XML_TRANSLATION_SHEETS = {
  [ConfiguratorType.System]: {
    sheetName: "unitConfigurator",
    tPrefix: "configurator.unit",
  },
  [ConfiguratorType.Rail]: {
    sheetName: "railConfigurator",
    tPrefix: "configurator.rail",
  },
  [ConfiguratorType.Carriage]: {
    sheetName: "carriageConfigurator",
    tPrefix: "configurator.carriage",
  },
  [ConfiguratorType.MetricShaft]: {
    sheetName: "shaftConfigurator",
    tPrefix: "configurator.shaft",
  },
  [ConfiguratorType.InchShaft]: {
    sheetName: "shaftConfigurator",
    tPrefix: "configurator.shaft",
  },
  [ConfiguratorType.BallScrew]: {
    sheetName: "ballscrewConfigurator",
    tPrefix: "configurator.ballScrew",
  },
  [ConfiguratorType.Actuator]: {
    sheetName: "EMA-100Configurator",
    tPrefix: "configurator.actuator",
  },
} as const;

export const getXmlConfiguratorTranslationConfig = (productCode: string) => {
  const configuratorType = getConfiguratorTypeFromProductCode(productCode);
  return configuratorType === null ? undefined : XML_TRANSLATION_SHEETS[configuratorType];
};
